<template>
  <ul class="flex color_666 state">
    <li class="mr10 color_main flex0" v-if="info.docPicConsultStatus">
      <img class="mr5 flex0" src="../../../assets/icon/icon.pic.png" alt="">
      <div class="flex0">图文</div>
    </li>
    <li class="mr10 color_main flex0" v-if="info.docVideoConsultStatus||info.docFamousConsultStatus">
      <img class="mr5 flex0" src="../../../assets/icon/icon.video.png" alt="">
      <div class="flex0">视频</div>
    </li>
    <li class="mr10 color_main flex0" v-if="info.teamConsultStatus">
      <img class="mr5 flex0" src="../../../assets/icon/icon.team.png" alt="">
      <div class="flex0">团队</div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "doc-services",
  props: {
    info: {
      type: Object,
      default: () => Object.create(null)
    },
  },
}
</script>

<style scoped lang="scss">
@import "../../../common/public";

.state {
  img {
    height: px2rem(15px);
  }

  li {
    align-items: center;
    display: flex;

    div {
      word-break: break-word;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/group/components/doc-services.vue